'use client';

import React from 'react';
import { MarketType } from '@velocity-exchange/sdk';
import { MAIN_POOL_ID, matchEnum } from '@velocity-exchange/common';
import { PerpTradeForm } from './PerpTradeForm/PerpTradeForm';
import { SpotTradeForm } from './SpotTradeForm';
import { IsolatedPoolsContentBlock } from './IsolatedPoolsContentBlock';
import { cm } from 'src/utils/classNames';
import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';

interface Props {
	marketType: MarketType;
	className?: string;
}

const TradeForm_ = ({ marketType, className }: Props) => {
	const shouldShowIsolatedPoolsContentBlock = useVelocityAccountStore((s) => {
		const userAccount = s.getCurrentUserAccount()?.client?.getUserAccount();

		if (!userAccount) {
			return false;
		}

		return userAccount.poolId !== MAIN_POOL_ID;
	});
	const numberOfSubAccounts = useVelocityAccountStore(
		(s) => Object.keys(s.accounts).length
	);

	return (
		<div
			id="trade_form"
			className={cm(
				'relative hidden-scroll flex h-auto flex-col justify-start overflow-x-hidden p-2 xl:p-3',
				className
			)}
		>
			{/** Isolated Pools Content Block */}
			{shouldShowIsolatedPoolsContentBlock && (
				<IsolatedPoolsContentBlock
					hasMultipleSubaccounts={numberOfSubAccounts > 1}
				/>
			)}

			{/** Actual Trade Form UI */}
			{matchEnum(marketType, MarketType.PERP) ? (
				<PerpTradeForm />
			) : (
				<SpotTradeForm />
			)}
		</div>
	);
};

export const TradeForm = React.memo(TradeForm_);
